<template>
  <div style="min-width:300px; display:flex; justify-content:space-between;">
    <div>
      <p style="line-height:12px;margin-bottom:5px;">
        {{
          $tc("admin.ptsCumulsNbColors.inscrit", insight_nb_participants, {
            count: insight_nb_participants,
          })
        }}
      </p>
      <img
        src="~@/assets/img/icons/completed.png"
        style="height:39px;width:39px;padding:6px;"
      />
    </div>
    <div>
      <p style="line-height:12px;margin-bottom:5px;">
        {{
          $tc("admin.ptsCumulsNbColors.attente", nb_participants_en_attente, {
            count: nb_participants_en_attente,
          })
        }}
      </p>
      <img
        src="~@/assets/img/icons/pending.png"
        style="height:39px;width:39px;padding:6px;"
      />
    </div>
    <div>
      <p style="line-height:12px;margin-bottom:5px;">
        {{
          $tc(
            "admin.ptsCumulsNbColors.fini",
            insight_nb_participants - nb_participants_en_attente,
            {
              count: insight_nb_participants - nb_participants_en_attente,
            }
          )
        }}
      </p>
      <img
        src="~@/assets/img/icons/registered.png"
        style="height:39px;width:39px;padding:6px;"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["insight_nb_participants", "nb_participants_en_attente"]),
  },
};
</script>
